import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_CONSULTING_BASE_URL;

export const downloadExemploPerguntas = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/aws/exemplo-perguntas`);
    const { url } = response.data;
    
    // Criar link temporário e fazer o download
    const link = document.createElement('a');
    link.href = url;
    link.download = 'ExemploPerguntas.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Erro ao baixar arquivo exemplo:', error);
    throw new Error('Erro ao baixar arquivo exemplo');
  }
};
